import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/** Safe localStorage wrapper that silently catches quota/security errors */
export const safeStorage = {
    getItem(key: string): string | null {
        try {
            return localStorage.getItem(key);
        } catch {
            return null;
        }
    },
    setItem(key: string, value: string): void {
        try {
            localStorage.setItem(key, value);
        } catch {
            // quota exceeded or security error - silently fail
        }
    },
    removeItem(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch {
            // silently fail
        }
    },
};
